import { Schema, defineTable } from 'squid';
const jobAssignmentFields = {
    job_id: Schema.String,
    assignee_type: Schema.String,
    assignee_id: Schema.String,
};
export const jobMonoAssignmentTable = defineTable('job_mono_assignment', jobAssignmentFields);
export const jobPolyAssignmentTable = defineTable('job_poly_assignment', jobAssignmentFields);
